import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import clsx from 'clsx';

const { FiLock, FiStar, FiCheck } = FiIcons;

const BrandKitCard = ({ kit, isActive, onSetActive }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString('en-US', {
      month: 'numeric',
      day: 'numeric',
      year: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className={clsx(
        "bg-white rounded-lg p-4 shadow-sm border-2 transition-all duration-200",
        isActive ? 'border-blue-500' : 'border-gray-200 hover:border-gray-300'
      )}
    >
      <div className="flex items-start justify-between mb-2">
        <h3 className="font-semibold text-gray-900 flex items-center">
          {kit.name || 'Untitled Kit'}
          {!isActive && <SafeIcon icon={FiLock} className="w-4 h-4 text-yellow-500 ml-2" />}
        </h3>
        {isActive && (
          <div className="flex items-center space-x-1 text-xs font-medium text-blue-600 bg-blue-100 px-2 py-0.5 rounded-full">
            <SafeIcon icon={FiStar} className="w-3 h-3" />
            <span>Active</span>
          </div>
        )}
      </div>
      <p className="text-xs text-gray-500 mb-3">
        Modified: {formatDate(kit.updated_at)}
      </p>

      {kit.colors && Object.keys(kit.colors).length > 0 && (
        <div className="flex mb-3 rounded-full overflow-hidden">
          {Object.values(kit.colors).slice(0, 5).map((color, index) => (
            <div
              key={index}
              className="w-1/5 h-2"
              style={{ backgroundColor: color }}
            />
          ))}
        </div>
      )}

      <div className="flex items-center justify-between text-xs text-gray-500 mb-4">
        <span>Logos: {kit.logos?.length || 0}</span>
        <span>Watermarks: {kit.watermarks?.length || 0}</span>
      </div>

      <button
        onClick={onSetActive}
        disabled={isActive}
        className={clsx(
          "w-full py-2 px-3 rounded-lg text-sm font-medium transition-colors flex items-center justify-center space-x-2",
          isActive
            ? 'bg-green-100 text-green-700 cursor-default'
            : 'bg-blue-600 text-white hover:bg-blue-700'
        )}
      >
        {isActive ? (
          <>
            <SafeIcon icon={FiCheck} className="w-4 h-4" />
            <span>Active Kit</span>
          </>
        ) : (
          <span>Set Active</span>
        )}
      </button>
    </motion.div>
  );
};

export default BrandKitCard;